import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetInitiativeFileRequest = {
	fileId: number;
	initiativeId: number;
};

export const getInitiativeFile = createGetEndpoint<GetInitiativeFileRequest, Blob>(
	({ fileId, initiativeId }) => `/api/v3/initiatives/${initiativeId}/files/${fileId}/download`,
	{
		responseIsBlob: true
	}
);
